// Découpe le sujet d'une LM (« NOM - [complément - ] TYPE ») pour les cartes
// du Lead. Le type est toujours la DERNIÈRE partie : lire la deuxième
// affichait le nom commercial à la place du type quand le sujet en compte
// trois (« SEVAI FABRICE - LE CLOS GENTIL - LM Globale EI »).
export function decouperSujetLM(sujet) {
  const parties = (sujet || "").split(" - ").map((p) => p.trim());
  if (parties.length < 2) return { nom: parties[0] || "", complement: "", type: "" };
  return {
    nom: parties[0],
    complement: parties.slice(1, -1).join(" - "),
    type: parties[parties.length - 1],
  };
}

export const tronquer = (texte, max) =>
  texte && texte.length > max ? texte.slice(0, max) + "..." : texte;
